import * as React from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { getChatState } from '../../selectors/chat';
import { CHAT_STATE } from '../../constants';
import { ROUTES } from '../../constants/routes';

const WELCOME_SCREEN_STATES = [
  CHAT_STATE.REQUESTING_CHAT,
  CHAT_STATE.NO_AVAILABLE_OPERATOR,
  CHAT_STATE.CURRENTLY_CHATTING
];

const ChatRouteHandler = () => {
  const chatState = useSelector(getChatState);
  const history = useHistory();

  React.useEffect(() => {
    if (chatState === CHAT_STATE.LOGIN_PRESALES) {
      history.push(ROUTES.LOGIN);
    }

    if (chatState === CHAT_STATE.AUTHENTICATED_INQUIRY) {
      history.push(ROUTES.INQUIRY);
    }

    if (WELCOME_SCREEN_STATES.includes(chatState)) {
      history.push(ROUTES.WAITING_FOR_OPERATOR);
    }
  }, [chatState]);

  return null;
};

export default ChatRouteHandler;
